// 在线留言
<template>
  <div>
    <h1>在线留言</h1>

    <div style="margin-top: 2rem">
      <el-input
        id="select1"
        v-model="input1"
        placeholder="您的姓名"
        @input="check"
        class="Message"
      ></el-input>
      <el-input
        id="select2"
        v-model="input2"
        placeholder="您的电话"
        @input="check"
        class="Message"
      ></el-input>
      <el-input
        id="select3"
        v-model="input3"
        placeholder="您的邮箱"
        @input="check"
        class="Message"
      ></el-input>
      <el-input
        id="select4"
        v-model="input4"
        type="textarea"
        placeholder="合作意向"
        @input="check"
        class="Message"
        :autosize="{ minRows: 8, maxRows: 8 }"
        resize="none"
      ></el-input>
      <div class="btn">
        <el-button
          id="bt"
          type="primary"
          class="Button"
          @click="onlineMessage"
          :disabled="disabled"
          >提交</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import axios from 'axios'
export default {
  name: 'online',
  data () {
    return {
      input1: '',
      input2: '',
      input3: '',
      input4: '',
      currInput1: '',
      currInput2: '',
      currInput3: '',
      currInput4: '',
      count: 0,
      disabled: true,
      msg: '',
      image: '',
    }
  },
  created () {
    if (window.localStorage.getItem('contactImage')) {
      var image1 = JSON.parse(window.localStorage.getItem('contactImage'))
      this.image = image1.data.data.image
    }
  },
  methods: {

    async onlineMessage () {
      if (this.count < 1) {
        //   const { data:data } = api.getContact(this.input1,this.input2,this.input3,this.input4)
        //   this.msg = data.data
        //   this.open()
        axios({
          method: 'post',
          url: 'http://bjtstd.com.cn/tstd/message/',
        //   data: $httpParamSerializer({
        //     name: this.input1,
        //     phone: this.input2,
        //     email: this.input3,
        //     content: this.input4
        //   }),
                  data: {
            name: this.input1,
            phone: this.input2,
            email: this.input3,
            content: this.input4
          },
          heads: {
              'content-type' : 'application/x-www-form-urlencoded'
          }
        }).then(res => {
          console.log(res.data.msg)
          this.msg = res.data.msg
          this.open()
        }).catch(error => console.log('error1'))
      } else {
        this.open()
      }

    },
    check () {
      if (this.input1 == "" || this.input2 == "" || this.input3 == "" || this.input4 == "") {
        this.disabled = true
      } else {
        this.disabled = false
      }
      if (this.currInput1 != this.input1 || this.currInput2 != this.input2 || this.currInput3 != this.input3 || this.currInput4 != this.input4) {
        this.count = 0
      }
    },
    open () {
      if (this.count < 1 && this.msg == '发送成功') {
        this.currInput1 = this.input1
        this.currInput2 = this.input2
        this.currInput3 = this.input3
        this.currInput4 = this.input4
        console.log(this.msg)
        this.$alert('留言发布成功', '', {
          confirmButtonText: '确定',
        })
        this.count = 1
      }
      else {
        if (this.count < 1) {
          console.log('error', this.msg)
          this.$alert(this.msg.toString(), '', {
            confirmButtonText: '确定',
          })
          this.count = 0
        } else {
          this.$message({ message: '不能重复发送留言', offset: '300' });
        }
      }
    },
    goBack () {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/' })
        return false
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>
<style scoped>
h1 {
  margin-top: 3rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 2.125rem;
  line-height: 3rem;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
  color: #333333;
}
/* 全局配置box弹窗 */
.el-message-box {
  width: 35.875rem !important;
  height: 12.75rem !important;
  border-radius: 0.5rem !important;
}
.el-button--small.is-round {
  padding: 0rem !important;
  background-color: #ffffff !important;
  color: #0099da !important;
  border: none !important;
  margin-top: 2.5rem !important;
  margin-right: 1rem !important;
  font-size: 1.8125rem !important;
}
.el-message-box__message p {
  height: 2.4375rem !important;
  font-size: 1.75rem;
  color: #333333;
  margin-left: 2.625rem !important;
  padding-top: 1.5rem !important;
}
/* 取消关闭按钮 */
.el-icon-close:before {
  content: "" !important;
}
/* 配置message弹框 */
.el-message {
  width: 19rem !important;
  height: 3.625rem !important;
  color: #ffffff !important;
  font-size: 1.5rem !important;
  background: #333333 !important;
  border-radius: 0.5rem !important;
}
.el-message--info .el-message__content {
  color: #ffffff !important;
  text-align: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
/* 取消头部icon */
.el-icon-info:before {
  content: "" !important;
}
</style>
<style scoped>
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 24.125rem;
}
.Message {
  width: 43.875rem;
  /* margin: 1rem 1.5rem; */
  margin-top: 2rem;
  margin-left: 1.5rem;
  color: #333333;
  font-size: 1.5rem;
}
/deep/ .el-input__inner {
  background-color: #f5f5f5 !important;
  height: 4.875rem;
  /* font-size: inherit; */
}
/deep/ .el-textarea__inner {
  background-color: #f5f5f5;
}
.btn {
  width: 43.875rem;
  height: 3.125rem;
  text-align: center;
  /* margin-left: 17.4375rem; */
  margin-top: 3.5rem;
  margin-left: 1.625rem;
  margin-bottom: 3.5rem;
}
.Button {
  width: 12rem;
  height: 3.125rem;
  border-radius: 0.625rem;
  padding: 0;
}
.el-button--primary {
  font-size: 1.5rem;
}
/deep/ .el-button--primary{
    background-color: #0099da !important;
}
/deep/ .el-button Button el-button--primary{
    color: #0099da !important;
}
/deep/ .el-message {
  margin-top: 12.5rem !important;
  padding-top: 12.5rem !important;
}
</style>
